import logger from "../utils/logger";

export async function getDashboardFinanceStats() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: `SELECT ROUND(SUM(ROUND(IFNULL(finance.payment, 0), 2)),2) as sum_of_payment FROM finance WHERE _d > '2024-12-31'`,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getDashboardFinanceStats failed", {}, error);
        return [];
    }
}

export async function getDashboardEmployeesStats() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/consultant/distinct?_where=(active,eq,1)~and(entity,eq,MTINC)");
        return await response.json();
    } catch (error) {
        logger.error("getDashboardEmployeesStats failed", {}, error);
        return [];
    }
}

export async function getProjectCountStats() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/project_master/distinct?_where=(active,eq,1)");
        return await response.json();
    } catch (error) {
        logger.error("getProjectCountStats failed", {}, error);
        return [];
    }
}
export async function getbillStats() {
    try {
               let _q = "SELECT sum(project.rate * finance.hrs) as bill FROM finance LEFT JOIN consultant ON consultant.uuid = finance.uuid LEFT JOIN project ON consultant.uuid = project.uuid AND finance._d BETWEEN project.start_dt AND project.end_dt LEFT JOIN project_master ON project.pid = project_master.pid WHERE finance._d > '2024-12-31'";

        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["finance"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getbillStats failed", {}, error);
        return [];
    }
}
